export const GLOBAL_SETTINGS_ID = "spieleladenglobalsettings";

export const WEIGHT_OPTIONS = [
  { value: "t", label: "Tonne (t)" },
  { value: "kg", label: "Kilogramm (kg)" },
  { value: "g", label: "Gramm (g)" },
  { value: "mg", label: "Milligramm (mg)" },
];
